<template>
  <div class="height100 box sort-label">
    <div class="font-18 sl-title">{{ title }}</div>
    <div class="whiteBg sl-content">
      <div class="box box-align-center box-pack-between slc-btns">
        <el-button type="primary" size="mini" @click="showAddTag">添加分类</el-button>
        <el-button type="danger" size="mini" @click="delLabel">删除分类</el-button>
      </div>
      <el-tree :data="list" node-key="id" default-expand-all @getCurrentKey="getCurrentKey"
        @check-change="handleCheckChange" @node-drag-start="handleDragStart" @node-drag-enter="handleDragEnter"
        @node-drag-leave="handleDragLeave" @node-drag-over="handleDragOver" @node-drag-end="handleDragEnd"
        @node-drop="handleDrop" @node-click="handleNodeClick" draggable :allow-drop="allowDrop" :allow-drag="allowDrag">
      </el-tree>
    </div>
    <el-dialog title="新建标签" :visible.sync="addTag" width="50%" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="分类名称：" required>
          <el-input v-model="sortName" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 24px; margin-right: 20px">
          <el-button type="primary" plain @click="createTag">保存</el-button>
          <el-button type="danger" class="ml12" plain @click="() => (addTag = false)">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
var that = null;
export default {
  props: {
    title: {
      type: String,
      default: '分类展示',
    },
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      addTag: false, //新增标签弹窗
      sortName: '',
      parentId: '',
      chooseList: [], //已选择列表
    };
  },
  mounted() {
    that = this;
  },
  methods: {
    showAddTag() {
      that.sortName = '';
      that.addTag = true;
    },
    clearData() {
      console.log('clearData');
      that.parentId = '';
    },
    showAddTag() {
      that.sortName = '';
      that.addTag = true;
    },
    closeDialog() {
      that.addTag = false;
    },
    // 节点被点击时的回调
    handleNodeClick(nodeVal) {
      console.log(nodeVal.value);
      that.parentId = nodeVal.value;
      that.$emit('nodeClick', nodeVal.value);
    },
    //删除标签
    delLabel() {
      if (!that.parentId) {
        this.$message({
          message: '请选择标签',
          type: 'warning'
        });
        return;
      } else {
        that.$emit('delLabel', that.parentId);
      }
    },
    createTag() {
      if (!that.sortName) {
        this.$message({
          message: '请输入分类名称',
          type: 'warning'
        });
        return;
      }
      let obj = {
        id: '',
        parentId: that.parentId ? that.parentId : 0,
        name: that.sortName
      }
      that.$emit('createTag', obj);
    },
    getCurrentKey(a, b) {
      console.log('1111', a, b)
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
      that.parentId = data.value;
    },
    handleDragStart(node, ev) {
      // console.log('drag start', node);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      // console.log('tree drag enter: ', dropNode.label);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      // console.log('tree drag leave: ', dropNode.label);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      // console.log('tree drag over: ', dropNode.label);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      console.log('tree drag end: ', draggingNode, dropNode);
      that.$emit('handleDragEnd', draggingNode, dropNode);

    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      // console.log('tree drop: ', dropNode.label, dropType);
    },
    allowDrop(draggingNode, dropNode, type) {
      // if (dropNode.data.label === '二级 3-1') {
      //     return type !== 'inner';
      // } else {
      return true;
      // }
    },
    allowDrag(draggingNode) {
      return draggingNode.data.label.indexOf('三级 3-2-2') === -1;
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  display: flex;
}

.sort-label {
  width: 258px;
  flex-direction: column;

  .sl-content {
    flex: 1;
    padding: 22px 32px;
    margin-top: 12px;

    .slc-btns {
      margin-bottom: 12px;
    }
  }
}
</style>
